import { render, staticRenderFns } from "./CompareReport.vue?vue&type=template&id=3d72ee4c&scoped=true"
import script from "./CompareReport.vue?vue&type=script&lang=js"
export * from "./CompareReport.vue?vue&type=script&lang=js"
import style0 from "./CompareReport.vue?vue&type=style&index=0&id=3d72ee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72ee4c",
  null
  
)

export default component.exports